import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ShiftPoisApi = createApi({
  reducerPath: "ShiftPois",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1/technicians`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  tagTypes: ["ShiftPois"],
  endpoints: (builder) => ({
    getShiftPois: builder.query({
      query: ({ technicianId, scope }) =>
        `/${technicianId}/shift-pois?scope=${scope}`,
      providesTags: (result, error, { technicianId, scope }) => [
        { type: "ShiftPois", id: `${technicianId}-${scope}` },
      ],
    }),
    addShiftPois: builder.mutation({
      query: ({ technicianId, poiIds, scope }) => ({
        url: `/${technicianId}/shift-pois`,
        method: "POST",
        body: { poiIds, scope },
      }),
      invalidatesTags: (result, error, { technicianId, scope }) => [
        { type: "ShiftPois", id: `${technicianId}-${scope}` },
      ],
    }),
    removeShiftPoi: builder.mutation({
      query: ({ technicianId, poiId }) => ({
        url: `/${technicianId}/shift-pois/${poiId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ShiftPois"],
    }),
  }),
});

export const {
  useGetShiftPoisQuery,
  useAddShiftPoisMutation,
  useRemoveShiftPoiMutation,
} = ShiftPoisApi;
